import FocusControls from "Layouts/Focus/FocusControls";
import { observer } from "mobx-react";
import React from "react";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { useStore } from "../../../../utils/useStore";
import { RuleBuildStore } from "./RuleBuildStore";
import MainRuleBuilder from "./Views/MainRuleBuilder";
import theme from "Theme/AppTheme";

const RuleBuilder = observer(() => {
    const store = useStore(RuleBuildStore);

    return (
        // @ts-expect-error: error coming from outdated react-dnd package prop types
        <DndProvider backend={HTML5Backend}>
            <FocusControls
                title={"Rule Builder"}
                controlHeaderSx={{ marginBottom: theme.spacing(10) }}
                loading={store.anyTaskLoading}
                controlHeader={null}
                onCancel={() => {
                    store.resetStore();
                }}
                mainContent={<MainRuleBuilder />}
                showSave={store.isSavable}
                onSave={() => store.saveToServer()}
            />
        </DndProvider>
    );
});

export default RuleBuilder;
